import api from "./api";

class AutomatizadorAPI {
  async buscarInfoCadastroAutomatizador(headers) {
    const response = await api.get("/buscar_info_cadastro_automatizador", { headers });
    return response;
  }

  async buscarAutomatizadores(headers) {
    const response = await api.get("/buscar_automatizadores", { headers });
    return response;
  }

  async saveNovaAutomatizacao(headers, params) {
    const response = await api({
      method: 'post',
      url: '/save_nova_automatizacao',
      headers,
      data: params
    });
    return response;
  }

  async deleteAutomatizador(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delelte_automatizador',
      headers,
      data: params
    });
    return response;
  }
}

export default new AutomatizadorAPI();
